import React, { useEffect, useState } from "react";
import ModeListing from "./ModeListing";
import { columnTypes } from "src/components/UI/atoms/ATMTable/ATMTable";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import {
  setIsOpenAddDialog,
  setIsOpenEditDialog,
  setPage,
  setRowsPerPage,
  setSearchValue,
  setIsTableLoading,
  setItems,
  setTotalItems,
} from "src/redux/slices/ModeSlice";
import AddModeWrapper from "../Add/AddModeWrapper";
import EditModeWrapper from "../Edit/EditModeWrapper";
import ATMMenu from "src/components/UI/atoms/ATMMenu/ATMMenu";
import { showConfirmationDialog } from "src/utils/showConfirmationDialog";
import { showToast } from "src/utils/showToaster";
import {
  useChangeStatusModeByIdMutation,
  useDeleteModeByIdMutation,
  useGetAllModeDataQuery,
} from "src/services/ModeServices";
import { Tooltip } from "@mui/material";
import { usePermission } from "src/hooks/usePermission";
type Props = {};

const ModeListingWrapper = (props: Props) => {
  const dispatch = useDispatch();
  const {
    items,
    totalItems,
    page,
    rowsPerPage,
    searchValue,
    isOpenAddDialog,
    isOpenEditDialog,
    isTableLoading,
  } = useSelector((state: RootState) => state.mode);
  const [deleteMode] = useDeleteModeByIdMutation();
  const [changeStatusMode] = useChangeStatusModeByIdMutation();
  const [selectedModeId, setSelectedModeId] = useState<string>();

  const { data, isLoading, isFetching } = useGetAllModeDataQuery({
    limit: rowsPerPage,
    searchValue: searchValue,
    params: ["modeName"],
    page: page,
    filterBy: [],
    dateFilter: {},
    orderBy: "createdAt",
    orderByValue: -1,
    isPaginationRequired: true,
  });

  // Setting Module Data
  useEffect(() => {
    if (isLoading || isFetching) {
      dispatch(setIsTableLoading(true));
    } else {
      dispatch(setItems(data?.data || []));
      dispatch(setIsTableLoading(false));
      dispatch(setTotalItems(data?.totalItem || 0));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isLoading, isFetching]);

  const handleDeleteMode = (row: string) => {
    showConfirmationDialog({
      title: "Hands Up",
      text: "Are you sure want to delete this Mode ?",
      icon: "question",
      showCancelButton: true,
      next: (result) => {
        if (result?.isConfirmed) {
          deleteMode(row).then((res: any) => {
            if (res.error) {
              showToast("error", res?.error?.data?.message);
            } else {
              showToast("success", res?.data?.message);
            }
          });
        }
      },
    });
  };

  const handleChangeStatusMode = (row: string) => {
    showConfirmationDialog({
      title: "Hands Up",
      text: "Are you sure want to change status of this Mode ?",
      icon: "question",
      showCancelButton: true,
      next: (result) => {
        if (result?.isConfirmed) {
          changeStatusMode({ id: row }).then((res: any) => {
            if (res.error) {
              showToast("error", res?.error?.data?.message);
            } else {
              showToast("success", res?.data?.message);
            }
          });
        }
      },
    });
  };

  const moduleName = "MODE";

  const canEdit = usePermission(moduleName, "UPDATE");
  const canDelete = usePermission(moduleName, "DELETE");
  const canActive = usePermission(moduleName, "ACTIVE/DEACTIVE");
  const columns: columnTypes[] = [
    {
      field: "modeName",
      headerName: "Mode Name",
      flex: "flex-[1.5_1.5_0%]",
    },
    {
      field: "modeCode",
      headerName: "Mode Code",
      flex: "flex-[1.5_1.5_0%]",
    },
    {
      field: "bookType",
      headerName: "Book Type",
      flex: "flex-[1.5_1.5_0%]",
    },
    {
      field: "description",
      headerName: "Description",
      flex: "flex-[1.5_1.5_0%]",
      renderCell: (row: any) => (
        <Tooltip title={row?.description || "-"}>
          <div className="line-clamp-2 text-[14px]  break-words max-w-[250px]">
            {" "}
            {row?.description || "-"}{" "}
          </div>
        </Tooltip>
      ),
    },
    // {
    //   field: "modeCode",
    //   headerName: "Mode Code",
    //   flex: "flex-[1.5_1.5_0%]",
    //   renderCell: (row: any) => (
    //     <Tooltip title={row?.modeCode}>
    //       <div className="capitalize text-[13px]"> {row?.modeCode} </div>
    //     </Tooltip>
    //   ),
    // },
    {
      field: "action",
      headerName: "Actions",
      flex: "flex-[1_1_0%]",
      extraClasses: "",
      align: "center",
      renderCell: (row: any) => {
        const options = [];

        if (canEdit) {
          options.push({
            label: "Edit",
            onClick: () => {
              dispatch(setIsOpenEditDialog(true));
              setSelectedModeId(row?._id);
            },
          });
        }
        if (canActive) {
          options.push({
            label: "Active/Deactive",
            onClick: () => {
              handleChangeStatusMode(row?._id);
            },
          });
        }
        if (canDelete) {
          options.push({
            label: "Delete",
            onClick: () => {
              handleDeleteMode(row?._id);
            },
          });
        }

        return <ATMMenu options={options} />;
      },
    },
  ];

  return (
    <>
      <div>
        <ModeListing
          columns={columns}
          rows={items}
          paginationProps={{
            isTableLoading,
            totalItems,
            page,
            rowsPerPage,
            searchValue,
            setPage: (newPage) => dispatch(setPage(newPage)),
            setRowsPerPage: (newRowsPerPage) =>
              dispatch(setRowsPerPage(newRowsPerPage)),
            setIsOpenAddDialog: (value) => dispatch(setIsOpenAddDialog(value)),
            setSearchValue: (newValue) => dispatch(setSearchValue(newValue)),
          }}
        />
      </div>
      {isOpenAddDialog ? (
        <AddModeWrapper onClose={() => dispatch(setIsOpenAddDialog(false))} />
      ) : null}
      {isOpenEditDialog ? (
        <EditModeWrapper
          onClose={() => dispatch(setIsOpenEditDialog(false))}
          selectedModeId={selectedModeId || ""}
        />
      ) : null}
    </>
  );
};

export default ModeListingWrapper;
